<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 20H0V0H20V20ZM7.79541 6.96615L2.07438 7.42513L6.43392 11.1589L5.10173 16.7415L10 13.75L14.8983 16.7415L13.5661 11.1589L17.9256 7.42513L12.2046 6.96615L10 1.66667L7.79541 6.96615Z"
    fill="currentColor"
/>
